/** 黑名单 */
<template>
  <div class="home protocol-home">
    <Layout
      type="HOME"
      pageTitle="供给方管理"
      titleSrc="/menu/homeIcon_black.png"
    >
      <BasiceLayout
        title="账号余额增加"
        class="bonus-code-layout"
      >
        <div class="balance-content">

          <div class="balance-item display-flex-center">
            <div class="span  balence-text">操作账号</div>
            <div class="span balence-text">
              <el-input
                v-model="addEmail"
                class="bonus-input"
                placeholder="输入要添加的账号"
              ></el-input>
            </div>
            <div
              class="button   balence-text"
              @click="getBalance('add')"
            >查看余额</div>
            <div class="balence-text text-align-right">
              <div v-if="addBalance">
                余额 {{addBalance}}
              </div>
             </div>
          </div>
          <!-- 增加余额 -->
          <div class="balance-item display-flex-center">
            <div class="span balence-text">增加BxC数量</div>
            <div class="span balence-text">
              <el-input
                v-model="addCount"
                class="bonus-input "
                placeholder="输入要增加的BxC数量"
              ></el-input>
            </div>
            <div
              class="button balence-text"
              @click="sureAdd"
            >确定</div>
            <div class="balence-text text-align-right">
              <div v-if="addResult">
                操作结果： {{addResult}}
              </div>
            </div>
          </div>
        </div>
      </BasiceLayout>
      <BasiceLayout
        title="账号余额减少"
        class="bonus-code-layout"
      >
        <div class="balance-content">

          <!-- 减少余额 -->
          <div class="balance-item display-flex-center">
            <div class="span balence-text">操作账号</div>
            <div class="span balence-text">
              <el-input
                v-model="reduceEmail"
                class="bonus-input "
                placeholder="输入要的账号"
              ></el-input>
            </div>
            <div
              class="button balence-text"
              @click="getBalance('reduce')"
            >查看余额</div>
            <div class="balence-text  text-align-right">
              <div v-if="reduceBalance">余额:{{reduceBalance}}</div>
              </div>
          </div>
          <!-- 增加余额 -->
          <div class="balance-item display-flex-center">
            <div class="span balence-text">减少BxC数量</div>
            <div class="span balence-text ">
              <el-input
                v-model="reduceCount"
                class="bonus-input"
                placeholder="输入要增加的BxC数量"
              ></el-input>
            </div>
            <div
              class="button balence-text"
              @click="sureReduce"
            >确定</div>
            <div class="balence-text text-align-right">
              <div v-if="reduceResult">
                操作结果： {{reduceResult}}
              </div>
            </div>
          </div>
        </div>
      </BasiceLayout>
      <!-- 操作列表 -->
      <BasiceLayout
        title="操作列表"
        class="bonus-code-layout"
      >
        <div class="margin-20 display-flex">
          <el-table
            v-if="balanceList && balanceList.length"
            :data="balanceList"
            style="width: 100%"
          >
            <el-table-column
              prop="email"
              label="账号"
              width="180"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="timestamp"
              label="操作时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.type == 1">增加</div>
                <div v-if="scope.row.type == 2">减少</div>
              </template>
            </el-table-column>
            <!-- 数量 -->
             <el-table-column
              prop="count"
              label="数量"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="操作账号"
              prop="operator"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="block display-flex-center">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="deviceSize"
            layout="total, prev, pager, next"
            :total="total">
            </el-pagination>
        </div>
      </BasiceLayout>

    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { log } from "util";
import { Message } from "element-ui";
import Layout from "@/components/CRM/Layout.vue";
import BasiceLayout from "@/components/Common/BasicLayout.vue";

export default {
  name: "home",
  data() {
    return {
      addEmail: "",
      addCount: "",
      reduceEmail: "",
      reduceCount: "",
      addBalance: "",
      reduceBalance: "",
      balanceList: "",
      addResult: "",
      reduceResult: "",
      pageSize: 1,
      currentPage: 1,
      deviceSize: 20,
      total: 0, //总数
    };
  },
  computed: mapState({}),
  components: {
    Layout,
    BasiceLayout,
  },
  methods: {
    ...mapActions(["getWithdrawalBalance", "setBalance", "getBalanceList"]),
    handleCurrentChange(val) {
      this.currentPage = val;

      this.getBalanceList({ page: val }).then(( res => {
        console.log(res)
        this.balanceList = res.data;
        this.total = Number(res.total);
      }));
    },
    sureAdd() {
      let { addEmail, addCount } = this;
      if (!addEmail || !addCount) {
        return Message({
          type: "error",
          message: "填写参数",
        });
      }

      this.setBalance({
        email: addEmail,
        count: addCount,
        type: 1,
      }).then((res) => {
        if (res.code === 200) {
          this.addResult = '成功'
          Message({
            type: "success",
            message: "操作成功",
          });
        } else {
          this.addResult = '失败'

          Message({
            type: "error",
            message: res.message || "操作失败",
          });
        }
      });
    },
    sureReduce() {
      let { reduceEmail, reduceCount } = this;
      if (!reduceEmail || !reduceCount) {
        return Message({
          type: "error",
          message: "填写参数",
        });
      }

      this.setBalance({
        email: reduceEmail,
        count: reduceCount,
        type: 2,
      }).then((res) => {
        if (res.code === 200) {
          this.reduceResult = '失败'

          Message({
            type: "success",
            message: "操作成功",
          });
        } else{
          this.reduceResult = '失败'

          Message({
            type: "error",
            message: res.message || "操作失败",
          });
        }
      });
    },
    getBalance(type) {
      let email;
      if (type === "add") {
        email = this.addEmail;
      } else {
        email = this.reduceEmail;
      }

      if (!email || !email.length) {
        return;
      }
      this.getWithdrawalBalance({
        queryEmail: email,
        type: "admin",
      }).then((res) => {
        if (type === "add") {
          this.addBalance = res.data.balance.amount;
        } else {
          this.reduceBalance = res.data.balance.amount;
        }
      });
    },
  },
  async created() {
   this.getBalanceList().then(( res => {
      console.log(res)
      this.balanceList = res.data;
      this.total = Number(res.total);
    }));
  },
};
</script>

<style  lang="stylus">
.balence-text {
  width: 25%;
  // margin: 20px 50px;
}

.balance-content{
  max-width: 80%;
  margin: 0 auto ;
  padding: 20px;
}
.balence-text{
  .el-input{
    max-width: 150px;
  }
  
}

.balence-text.button{
  max-width: 150px;
}
</style>

